import { render, staticRenderFns } from "./BaseTexarea.vue?vue&type=template&id=4a987048&scoped=true&"
import script from "./BaseTexarea.vue?vue&type=script&lang=js&"
export * from "./BaseTexarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a987048",
  null
  
)

export default component.exports